import { PersonData } from "../clients/data-service";

function isSuffix(nameFragment: string) : boolean {
    nameFragment = nameFragment.toLowerCase().replace(".", "");
    if (nameFragment === "jnr" ||
        nameFragment === "jr" ||
        nameFragment === "snr" ||
        nameFragment === "sr" 
    ) {
        return true;
    }

    return false;
}
export function PersonSurnameFirst(person: PersonData) : string {
    if (!person.name) {
        return "Unknown"; // should not occur
    }
    const pieces = person.name.split(' ');

    if (pieces[0].length === 1) {
        pieces[0] = pieces[0] + ".";
    }

    if (pieces.length === 1) {
        return person.name;
    }
    else if (pieces.length === 2) {
        return `${pieces[1]}, ${pieces[0]}`;
    }
    else if (pieces.length === 3) {
        if (isSuffix(pieces[2])) {
            return `${pieces[1]}, ${pieces[0]} ${pieces[2]}`;
        }
        return `${pieces[1]} ${pieces[2]}, ${pieces[0]}`;
    }
    else {
        let compound = pieces[1];
        for (var i = 2; i < pieces.length; i++) {
            compound += " " + pieces[i];
        }
        compound += ", " + pieces[0];
        return compound;
    }
}